const eaRest = document.querySelector('meta[name="ea_rest"]').content;
const eaTheme = document.querySelector('meta[name="ea_theme_build"]').content;
const eaLanguage = document.querySelector('meta[name="ea_language"]')?.content || '';
const eaCsrf = document.querySelector('meta[name="ea_csrf"]') || '';
const eaTranslations = window.eaTranslations || {};
export {eaRest, eaTheme, eaLanguage, eaCsrf, eaTranslations};
